const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b0acd5d66e110d892cee81a6f31fd64e4cf7a5c4"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["front@saweria"]={id:"b0acd5d66e110d892cee81a6f31fd64e4cf7a5c4"};
      